import type { PropsWithChildren } from 'react';
import { useUser } from '../context/page-context';

export function StaffOnly(props: PropsWithChildren) {
  const { isSparkStaff } = useUser();

  if (!isSparkStaff) {
    return null;
  }

  return props.children;
}
